import React, {
  useCallback,
} from 'react';
import {
  shallowEqual,
  useSelector,
  useDispatch,
} from 'react-redux';
import {
  selection,
} from 'redux-resource-plugins';

import {
  coreSelectors,
} from '@gymcloud/core';
import {
  Tree,
} from 'web-components';

import {
  Flex,
} from 'web-styled';

type Props = {
  resourceType: string,
};

const TreeEntities = ({ resourceType }: Props) => {
  const mapState = useCallback(state => ({
    treeData: coreSelectors.getTreeFoldersWithItems(
      resourceType,
    )(state),
  }), [resourceType]);

  const { treeData } = useSelector(mapState, shallowEqual);
  const dispatch = useDispatch();

  if (!treeData?.id) return null;

  const handleSelect = (data) => {
    const type = data.isFolder ? 'folders' : resourceType;
    dispatch(data.selected
      ? selection.deselectResources(type, [data.id])
      : selection.selectResources(type, [data.id]));
  };

  return (
    <Flex
      column
      scrollY
      shrink="0"
      spacing={10}
      width="100%"
      style={{
        maxHeight: 300,
      }}
    >
      {treeData.children.map(item => (
        <Tree
          key={item.id}
          treeData={item}
          checkable
          onSelect={(data) => handleSelect(data)}
        />
      ))}
    </Flex>
  );
};

export default TreeEntities;
